var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbahn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-full h-auto",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x33_0x30_5_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F35"
    },
    d: "M50,99C22.974,99,1,77.026,1,50C1,22.975,22.974,1,50,1c27.026,0,49,21.975,49,49 C99.001,77.026,77.025,99,50,99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M37.595,28.291c0-4.253,3.899-7.886,10.722-7.886c12.051,0,22.329,6.468,29.152,13.823V21.38 c-7.886-6.114-17.81-9.747-28.886-9.747c-13.291,0-28.089,8.152-28.089,23.304c0,28.886,43.861,18.519,43.861,35.266 c0,4.43-5.848,8.595-13.114,8.595c-11.873,0-23.658-7.177-30.127-16.481v15.417c6.823,6.114,19.316,10.987,30.127,10.987 c19.405,0,30.924-13.823,30.924-25.696C82.165,33.608,37.595,46.189,37.595,28.291z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbahn);
export default __webpack_public_path__ + "static/media/sbahn.dbe5be9df544bb02499a6eff8c7460a4.svg";
export { ForwardRef as ReactComponent };